import React from "react";

import {
    Landmark,
    User,
    CreditCard,
    Building2,
    Smartphone,
    BadgeCheck,
    CheckCircle,
    Clock3
} from "lucide-react";

import "./BankInfo.css";

function BankInfo({ profile }) {

    const bank = profile?.bank || {};

    const maskAccountNumber = (number) => {

        if (!number) return "Not Added";

        const str = number.toString();

        return "XXXX XXXX " + str.slice(-4);

    };

    const bankDetails = [

        {
            title: "Bank Name",
            value: bank.bankName || "Not Added",
            icon: <Landmark size={22} />
        },

        {
            title: "Account Holder",
            value: bank.accountHolder || "Not Added",
            icon: <User size={22} />
        },

        {
            title: "Account Number",
            value: maskAccountNumber(bank.accountNumber),
            icon: <CreditCard size={22} />
        },

        {
            title: "IFSC Code",
            value: bank.ifsc || "Not Added",
            icon: <Building2 size={22} />
        },

        {
            title: "UPI ID",
            value: bank.upiId || "Not Added",
            icon: <Smartphone size={22} />
        }

    ];

    return (

        <div className="hf-bank-card">

            <div className="hf-bank-header">

                <div>

                    <h2>

                        Bank Details

                    </h2>

                    <p>

                        Your payment information

                    </p>

                </div>

            </div>

            <div className="hf-bank-grid">

                {

                    bankDetails.map((item,index)=>(

                        <div
                            key={index}
                            className="hf-bank-item"
                        >

                            <div className="hf-bank-icon">

                                {item.icon}

                            </div>

                            <div className="hf-bank-content">

                                <span>

                                    {item.title}

                                </span>

                                <h4>

                                    {item.value}

                                </h4>

                            </div>

                        </div>

                    ))

                }

            </div>

            <div className="hf-bank-verification">

                <div className="hf-bank-left">

                    <BadgeCheck size={22} />

                    <div>

                        <h3>

                            Verification Status

                        </h3>

                        <p>

                            {

                                bank.isVerified

                                    ? "Your bank account has been verified."

                                    : "Verification is pending."

                            }

                        </p>

                    </div>

                </div>

                <div
                    className={`hf-bank-badge ${
                        bank.isVerified
                            ? "hf-verified"
                            : "hf-pending"
                    }`}
                >

                    {

                        bank.isVerified ? (

                            <>

                                <CheckCircle size={16} />

                                Verified

                            </>

                        ) : (

                            <>

                                <Clock3 size={16} />

                                Pending

                            </>

                        )

                    }

                </div>

            </div>

        </div>

    );

}

export default BankInfo;